export default __webpack_public_path__ + "static/patio-v4-4-c1336d73c86cd0bf3ded5e5c3c3bbfae.jpg";